
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./PauseAdmList.css";
import {
  withBase,
  Button,
  LayerPopup,
  ControlBox,
  Pagination,
} from "components";
import { useSelector } from "react-redux";
import moment from "moment";
import PauseAdmListConditionBox from "./PauseAdmListConditionBox";
import PauseAdmListTable from "./PauseAdmListTable";
import PauseAdmListPopupWrapper from "./PauseAdmListPopupWrapper";
import PauseAdmListPopupIndividual from "./PauseAdmListPopupIndividual";
import PauseAdmListPopupBatch from "./PauseAdmListPopupBatch";
import PauseAdmListPopupDown from "./PauseAdmListPopupDown";

const API = {
  LIST: {
    url: "api/v1/finnc/finnc/listPauseAdm",
    method: "post",
  },
  LISTPAUSE: {
    url: "api/v1/finnc/finnc/listPauseRmvPop",
    method: "post",
  },
  UPDATE: {
    url: "api/v1/finnc/finnc/updatePauseSend",
    method: "post",
  },
  REMIT: {
    url: "api/v1/finnc/finnc/updatePauseRemit",
    method: "post",
  },
  PAUSE: {
    url: "api/v1/finnc/finnc/updatePause",
    method: "post",
  },
};

const PauseAdmList = (props) => {
  const cretFlag = useSelector((state) => state.user.get("cretFlag"));
  const [param, setParam] = useState({
    //dspDate: moment().add(-1, "days").format("YYYYMMDD"),
    pageNo: 1,
  });
  const [datas, setDatas] = useState([]);
  const [total, setTotal] = useState(0);
  const [layerType, setLayerType] = useState("");
  const [viewData, setViewData] = useState(null);
  const [batchDatas, setBatchDatas] = useState([]);
  const [dateItem, setDateItem] = useState([]);
  const [batchAllDat, setBatchAllDat] = useState([]);
  const [batchAllChk, setBatchAllChk] = useState(false);
  const [states, setStates] = useState([]);
  const [pauseSeq, setPauseSeq] = useState(null);

  useEffect(() => {
    list();
    //readStates();
  }, [param]);

  const list = async () => {
    const { HttpRequest, searching } = props;
    searching(true);

    const { url, method } = API.LIST;
    const response = await HttpRequest.request(url, method, param);
    
    if (HttpRequest.hasError(response, true)) {
      setTotal(0);
      setDatas([]);
      setBatchDatas([]);
      searching(false);
      return;
    }
    setTotal(response.totalRowCnt);
    setDatas(response.fareFeeTxnPauseList);
    setBatchDatas([]);

    
/*     let checkDat = [];
    list &&
      list.forEach((item) => {
        if (item.status === "01" || item.status === "04") {
          checkDat.push(item.pauseSeq);
        }
      });
    setBatchAllDat(checkDat); */
    searching(false);
  };

  const readStates = async () => {
    const { HttpRequest, searching } = props;
    searching(true);

    const {url, method } = API.READSTATES;
    const response = await HttpRequest.request(url, method, {});

    if (HttpRequest.hasError(response, true)) {
    
      return;
    }

    setStates(response.stateMap);
    searching(false);

  };

  const edit = async ({ url, method }, data) => {
    const { HttpRequest } = props;
    const response = await HttpRequest.request(url, method, data);
    if (HttpRequest.hasError(response, true)) {
      return false;
    }
    setParam({
      ...param,
      pageNo: 1,
    });
    return true;
  };
  const handleClickSearch = (condition) => {
    setParam({
      ...condition,
      pageNo: 1,
    });
  };

  const handleClickDownOtpayReq = async (param) => {
    const { url } = API.DOWNOTPAYREQ;

    await props.downExcel.request(url, param);

    setLayerType("");
  };

  const handleClickDownFareFee = async () => {
    const { url } = API.DOWNFAREFEE;

    await props.downExcel.request(url, param);
  };

  const onChangeAllChk = (checked) => {
    setBatchAllChk(checked);

    if (checked) {
      setBatchDatas(batchAllDat);
    } else {
      setBatchDatas([]);
    }
  };

  const handleClickCheckBox = (index, check) => {
    check
      ? setBatchDatas([...batchDatas, index])
      : setBatchDatas(batchDatas.filter((item) => item !== index));
  };
  const handleDoubleClick = (index, type) => {
    setLayerType(type);
    let data = datas.filter((item) => item.pauseSeq === index).map((item) => ({
      ...item,
      selectType : (type === "pause") ? "Y" : ""
    }));
    pauseListPopup(index, data);
  };
  const handleClickDown = async () => {
    const { HttpRequest } = props;

    const { url, method } = API.DATELIST;

    const response = await HttpRequest.request(url, method, {});
    if (HttpRequest.hasError(response, true)) {
      setDateItem([]);
      return;
    }

    if (!response.PauseAdmListList || response.PauseAdmListList.length === 0) {
      setDateItem([]);
    } else {
      setDateItem(
        response.PauseAdmListList.map((item) => {
          return {
            code: item.dspDate,
            name: props.formatter(item.dspDate, "date"),
          };
        })
      );
    }

    setLayerType("down");
  };

  const handleClickPause = () => {
    if (batchDatas.length === 0) {
      props.toast.error("선택된 데이터가 없습니다.");
      return;
    }
    setLayerType("pause");
    pauseListPopup(datas.filter((item) => batchDatas.indexOf(item.pauseSeq) > -1));
  };

  const pauseListPopup = async (index, popupParam) => {
    const { HttpRequest, searching } = props;
    searching(true);
    const { url, method } = API.LISTPAUSE;
    
    const response = await HttpRequest.request(url, method,  { fareFeeTxnPauseList: popupParam });
    if (HttpRequest.hasError(response, true)) {
      setViewData(null);
      searching(false);
      return;
    }
    setViewData(response.fareFeeTxnList);
    let checkDat = [];
    response.fareFeeTxnList &&
    response.fareFeeTxnList.forEach((item) => {    
          checkDat.push(item.rowNum);
      });
    setBatchAllDat(checkDat);
    setBatchDatas(checkDat);
    setBatchAllChk(true);
    setPauseSeq(index);
    searching(false);
  };

  /*
  const handleClickDeposit = () => {
    if (batchDatas.length === 0) {
      props.toast.error("선택된 데이터가 없습니다.");
      return;
    }
    let data = [];
    data = datas.filter((item) => batchDatas.indexOf(item.rowNum) > -1);
    for (let i = 0; i < data.length; i++) {
      if(data[i].statusName !== "불능"){
        props.toast.error("이미 요청된 건은 중복 요청 불가합니다.");
        return;
      }
    }
    setLayerType("deposit");
    setViewData(datas.filter((item) => batchDatas.indexOf(item.rowNum) > -1));
  };
  */

  const handleClickPauseCancel = () => {
    if (batchDatas.length === 0) {
      props.toast.error("선택된 데이터가 없습니다.");
      return;
    }
    let data = [];
    data = datas.filter((item) => batchDatas.indexOf(item.rowNum) > -1);
    for (let i = 0; i < data.length; i++) {
      if(data[i].otpaySttus !== "정지요청" && data[i].otpaySttus !== "예치요청"){
        props.toast.error("정지/예치 요청된 건만 요청 취소가 가능합니다.");
        return;
      }
    }
    handleClickSave("cancel", data);
  };


  const handleClickClose = () => {
    setLayerType("");
    setViewData(null);
    setBatchDatas([]);
    setBatchAllChk(false);
  };
  const handleClickSave = async (saveType, data, index) => {
    //송금 리스트 없을 때 정지건 처리 하기 위함
    if(saveType !== "pauseNodata"){
      if (data.length === 0) {
        props.toast.error("선택된 데이터가 없습니다.");
        return;
      }
    }

    if (window.confirm("해제 또는 개별송금 요청 하시겠습니까?")) {
      let ret = false;
      let msg = "";

      switch (saveType) {
        case "pause":
            ret = await edit(API.UPDATE, { fareFeeTxnList: data });
            msg = "정지해제 요청 처리되었습니다.";
            if (ret) setBatchDatas([]);
          break;
        case "send":
            ret = await edit(API.UPDATE, { fareFeeTxnList: data });
            msg = "개별송금 요청 처리되었습니다.";
            if (ret) setBatchDatas([]);
            break;
        case "pauseNodata":
          ret = await edit(API.PAUSE, { pauseSeq : index });
          msg = "정지해제 요청 처리되었습니다.";
          if (ret) setBatchDatas([]);
          break;
        default:
          console.log(saveType);
          break; 
      }
      if (ret) {
        setLayerType("");
        setViewData(null);
      }
      if (msg) props.toast.error(msg);
    }
  };
  return (
    <div className="PauseAdmList">
      <PauseAdmListConditionBox onClickSearch={handleClickSearch} {...props} />
      {/* <ControlBox>
        <Button className="withdrawl_register" onClick={handleClickPause}>
            해제요청
        </Button>
      </ControlBox> */}
      <PauseAdmListTable
        datas={datas}
        batchDatas={batchDatas}
        onChange={handleClickCheckBox}
        onDoubleClick={handleDoubleClick}
        batchAllChk={batchAllChk}
        onChangeAllChk={onChangeAllChk}
        formatter={props.formatter}
        cretFlag={cretFlag}
      />
      {datas && datas.length > 0 && (
        <Pagination
          page={param.pageNo}
          total={total}
          row={15}
          pageCount={10}
          fetchData={(page) => {
            setParam({
              ...param,
              pageNo: page,
            });
          }}
        />
      )}
      <LayerPopup layerType={layerType} onClose={handleClickClose}>
        <PauseAdmListPopupWrapper
          layerType={layerType}
          title={"정지해제"}
          className={"PauseAdmListPopup"}
          batchTable={
            <PauseAdmListPopupBatch
              layerType={layerType}
              viewData={viewData}
              onClose={handleClickClose}
              onSave={handleClickSave}
              onChange={handleClickCheckBox}
              batchAllChk={batchAllChk}
              onChangeAllChk={onChangeAllChk}
              formatter={props.formatter}
              cretFlag={cretFlag}
              batchDatas={batchDatas}
              pauseSeq={pauseSeq}
            />
          }
          individualTable={
            <PauseAdmListPopupIndividual
              layerType={layerType}
              viewData={viewData}
              onClose={handleClickClose}
              onSave={handleClickSave}
              formatter={props.formatter}
              cretFlag={cretFlag}
            />
          }
          downTable={
            <PauseAdmListPopupDown
              onClose={handleClickClose}
              onDown={handleClickDownOtpayReq}
              dateItem={dateItem}
            />
          }
        />
      </LayerPopup>
    </div>
  );
};

PauseAdmList.propTypes = {};

export default withBase(PauseAdmList);
